import { createIcon } from '../utils';

export const ActiveIndicatorIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle className="opacity-30" cx="8" cy="8" r="8" />
      <circle cx="7.99973" cy="8.00047" r="4.22508" />
    </svg>
  ),
  {
    displayName: 'ActiveIndicatorIcon',
    defaultVariant: 'primary',
    defaultSize: 16,
    classNameBase: 'fill-current',
  },
);
